import {
  RoomJSONStructureSchema,
  SectionHeaderSchema,
} from '../../definitions/schemas';
import { RoomStructureItemType } from '../../enums/RoomStructureItemType';

/**
 * With the basic info, build a valid object to comply with SectionHeaderSchema
 */
export const buildSectionHeader = (
  name: string,
  icon?: string,
  signedUrl?: string,
  uri?: string,
  id = ''
): SectionHeaderSchema => ({ id, icon, name, signedUrl, sortOrder: 0, uri });

/**
 * Splits room from org section headers, so they can be grouped apart when
 * selecting a section header for a content that's being uploaded into a room
 */
export const getRoomSectionHeaderOptions = (
  sectionHeaders: SectionHeaderSchema[],
  structure?: RoomJSONStructureSchema
) => {
  const structureHeaders =
    structure?.items?.filter(
      ({ type }) => type === RoomStructureItemType.Header
    ) || [];

  // converting room structure headers to options that can be used by
  // the content uploader to distinguish from the org section headers
  const roomSectionHeaders: SectionHeaderSchema[] = structureHeaders.map(
    ({ customHeader, icon, id, name, logo }) => ({
      ...buildSectionHeader(name || '', icon, logo, '', id),
      isCustomHeader: customHeader,
      isRoomHeader: true,
    })
  );

  return [...roomSectionHeaders, ...sectionHeaders];
};
